 if (typeof observer === 'undefined') {
    var observer = new IntersectionObserver(() => {}); // empty callback
  }
  (function() {

  // Update cart count function
  function updateCartCount(count) {
    document.querySelectorAll('.js-header-cart-item-count')
      .forEach(el => el.textContent = count);
    document.querySelectorAll('.header__cart-count')
      .forEach(el => el.setAttribute('data-cart-count', count));
  }

  // Fetch current cart count from Shopify
  function fetchCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => updateCartCount(cart.item_count || 0))
      .catch(() => {});
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', fetchCartCount);

  // Observe changes in the cart drawer
  var cartDrawer = document.querySelector('#CartDrawer'); // change selector if your drawer has a different ID
  if (cartDrawer) {
    var observer = new MutationObserver(function() {
      fetchCartCount();
    });
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  // Optional: detect clicks on add-to-cart buttons
  document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function() {
      setTimeout(fetchCartCount, 500); // fetch after action
    });
  });

})();

document.addEventListener("DOMContentLoaded", function () {
  const progressBox = document.getElementById("volume-discount-progress");

  // 👉 Exit if progress bar is not on this page
  if (!progressBox) return;

  const progressText = progressBox.querySelector(".progress-text");
  const progressFill = progressBox.querySelector(".progress-bar-fill");

  function getSelectedVariantId() {
    const input = document.querySelector('input[name="id"]');
    return input ? Number(input.value) : null;
  }

  function fetchCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  function updateUI(cart) {
    const variantId = getSelectedVariantId();
    if (!variantId) {
      progressBox.style.display = "none";
      return;
    }

    const cartItem = cart.items.find(item => item.variant_id === variantId);
    if (!cartItem) {
      progressBox.style.display = "none";
      return;
    }

    const variantData = window.variantVolumeDiscounts?.find(v => v.id === variantId);
    if (!variantData || !variantData.tiers?.length) {
      progressBox.style.display = "none";
      return;
    }

    const cartQty = cartItem.quantity;
    const nextTier = variantData.tiers.find(t => cartQty < t.quantityThreshold);

    if (!nextTier) {
      progressBox.style.display = "none";
      return;
    }

    const remaining = nextTier.quantityThreshold - cartQty;
    const percent = Math.round((cartQty / nextTier.quantityThreshold) * 100);

    progressText.innerHTML = `
      ADD <strong>${remaining}</strong> MORE TO UNLOCK
      <strong>${nextTier.discountPercent}% OFF</strong>
    `;
    progressFill.style.width = percent + "%";
    progressBox.style.display = "block";
  }

  function sync() {
    fetchCart().then(cart => updateUI(cart));
  }

  sync();

  // Cart change watcher
  setInterval(sync, 1000);

  // Variant change watcher
  let lastVariant = getSelectedVariantId();
  setInterval(() => {
    const current = getSelectedVariantId();
    if (current !== lastVariant) {
      lastVariant = current;
      sync();
    }
  }, 300);
});



 (function () {
  const removeDisabled = () => {
    document.querySelectorAll('[disabled]').forEach(el => {
      el.removeAttribute('disabled');
      el.disabled = false;
    });
  };

  // 1️⃣ Remove on page load / refresh
  document.addEventListener('DOMContentLoaded', removeDisabled);

  // 2️⃣ Remove on any click
  document.addEventListener('click', removeDisabled);

  // 3️⃣ Prevent future additions (Shopify / JS safe)
  const observer = new MutationObserver(removeDisabled);
  observer.observe(document.documentElement, {
    attributes: true,
    subtree: true,
    attributeFilter: ['disabled']
  });
})();


  document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('searchInput');
  if (!searchInput) return; // prevents error if element not on page

  searchInput.addEventListener('input', function () {
    const searchVal = this.value.trim().toLowerCase();
    const products = document.querySelectorAll('.custom-main-inner-wrap');

    products.forEach(function (product) {
      const title = (product.getAttribute('data-title') || '').toLowerCase();

      if (searchVal === '' || title.includes(searchVal)) {
        product.style.display = 'block';
      } else {
        product.style.display = 'none';
      }
    });
  });
});


  document.getElementById('searchInput').addEventListener('input', function () {
    var searchVal = this.value.trim();
    var allTabs = document.querySelectorAll('.nav-tabs .tab-btn');
    var allProductsBtn = document.querySelector(".nav-tabs .tab-btn[onclick*='custom-all']");

    if (searchVal.length > 0) {
      // sab tabs hide karo
      allTabs.forEach(function (btn) {
        btn.classList.add('myhidden');
        btn.classList.remove('active-tab');
      });

      // All Products ko dikhana aur activate karna
      allProductsBtn.classList.remove('myhidden');
      allProductsBtn.classList.add('active-tab');

      // uska click trigger bhi karo
      allProductsBtn.click();
    } else {
      // sab tabs wapas show karo
      allTabs.forEach(function (btn, index) {
        btn.classList.remove('myhidden');
        btn.classList.remove('active-tab');
      });

      // pehli tab ko wapas active aur click karo
      let firstTab = allTabs[0];
      firstTab.classList.add('active-tab');
      firstTab.click();

      // All Products tab ko wapas hide karo
      allProductsBtn.classList.add('myhidden');
      allProductsBtn.classList.remove('active-tab');
    }
  });
  document.addEventListener('DOMContentLoaded', function () {

  function initLoadMore(wrapperSelector, buttonSelector, initialVisible = 10, increment = 10) {
    const wrapper = document.querySelector(wrapperSelector);
    if (!wrapper) return;

    const items = wrapper.querySelectorAll('.collection__item');
    const loadMoreBtn = document.querySelector(buttonSelector);
    if (!loadMoreBtn) return;

    let visible = initialVisible;

    // Hide all items initially
    items.forEach(item => item.style.display = 'none');

    // Show initial items
    for (let i = 0; i < visible && i < items.length; i++) {
      items[i].style.display = 'block';
    }

    // Hide button if not enough items
    if (items.length <= visible) loadMoreBtn.style.display = 'none';

    // Load more on button click
    loadMoreBtn.addEventListener('click', function () {
      const nextVisible = visible + increment;
      for (let i = visible; i < nextVisible && i < items.length; i++) {
        items[i].style.display = 'block';
      }
      visible = nextVisible;

      // Hide button if all items are shown
      if (visible >= items.length) loadMoreBtn.style.display = 'none';
    });
  }

  // Initialize for your dynamic wrapper
  initLoadMore('#dynamic', '.loadMore', 10, 10);

});

$('.grid_data').hide();
  $('.list-view-btn').click(function () {
    // Activate only the clicked list view button
    $('.list-view-btn').removeClass('active');
    $('.grid-view-btn').removeClass('active');
    $(this).addClass('active');

    // Toggle views
    $('.grid_data').hide();
    $('.custom-collection-page-tabcontent').show();
  });

  $('.grid-view-btn').click(function () {
    // Activate only the clicked grid view button
    $('.grid-view-btn').removeClass('active');
    $('.list-view-btn').removeClass('active');
    $(this).addClass('active');

    // Toggle views
    $('.grid_data').show();
    $('.collection__items').show(); // optional: if you use this elsewhere
    $('.custom-collection-page-tabcontent').hide();
  });


//collection

